import { getGlobalSelector } from './mmd';

const getRoot = () => getGlobalSelector().additionalSelectors.widgetSelectors;

export const getSponsor = (state: any) => getRoot().getSponsor(state);
export const isDealerUser = (state: any) => getRoot().isDealerUser(state);
